// @flow

import React, { type Node } from 'react';

import { Captcha } from '@tectonics/captcha/components';
import { useFormHasBeenSent } from '@tectonics/prs/form-status';
import { useUserInputValue } from '@tectonics/prs/user-input-values';
import { useIncomingPayment, getRecaptchaSiteKey } from '@tectonics/prs/incoming-payment';
import { useUserInputValidationError, type UserInputValidationError, serverErrorMessage } from '@tectonics/prs/validation';
import { useAutoResetCaptcha } from '@tectonics/captcha';

import { ErrorLabel } from '../../molecules/error-label';
import { translate } from '@tectonics/translate';

export function FieldCaptchaToken(): Node {
  const validationError = useUserInputValidationError('captchaToken');
  const [, handleChange] = useUserInputValue('captchaToken');
  const formHasBeenSent = useFormHasBeenSent();
  const incomingPayment = useIncomingPayment();
  const siteKey = getRecaptchaSiteKey(incomingPayment);
  const shouldResetCaptcha = useAutoResetCaptcha();

  return (
    <div data-error={formHasBeenSent && validationError ? 'error' : null}>
      <Captcha style={{ marginTop: '1em' }} siteKey={siteKey} setCaptchaToken={handleChange} shouldResetCaptcha={shouldResetCaptcha} />
      {formHasBeenSent && validationError && (
        <ValidationMessage validationError={validationError} />
      )}
    </div>
  );
}


type ValidationMessageProps = {|
  validationError: UserInputValidationError,
|};

function ValidationMessage({ validationError }: ValidationMessageProps): Node {
  const fallbackMessage = translate('captcha.fallback');
  const message = validationError.id === 'server-error' ? serverErrorMessage(validationError.payload, fallbackMessage) : fallbackMessage;

  return <ErrorLabel>{message}</ErrorLabel>;
}
